import React from 'react';

const SummaryComponent = () => {
  return (
    <div className="sidebar-container help-sidebar">
      <p className="light-grey-text">HELP</p>
      <h1 className="title">How would you describe yourself?</h1>
      <ul className="categoried-list">
        <li>This is your chance to briefly tell companies why you are the best candidate for the job!</li>
        <li>As a general rule, briefly summarize two to three of your top experiences and skills that show why you would be a successful engineer at top US software companies.</li>
      </ul>
      <h1 className="sub-title">Example</h1>
      <div className="panel">
        <p className="sub-title">How would you describe yourself?</p>
        <p className="alt-text">I&apos;m a software developer with 9 years of experience in developing web backend services in a variety of domains and tech-stacks. My strongest skills are Node.js and React, and I am an AWS Certified Engineer with 4+ years of experience in dealing with Cloud service providers like AWS &amp; GCP, DevOps Implementation, Build & Release engineering, and Linux administration.</p>
        <p className="alt-text">I&apos;m a experienced in designing system architectures and solutions for rapid scaling. I have significant experience working in startups and fast-moving teams with fixed deadlines. I am very flexible with different technologies and methodologies, and so am able to learn and adapt to new environments quickly.</p>
      </div>
    </div>
  );
};

export default SummaryComponent;
